module.exports = __webpack_public_path__ + "static/img/icon_mrtx_nan@2x.1984c2d5.png";